/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  HardwareActionTypes,
  HardwareState,
  Hardware,
  GetHardwareSuccess,
  GetHardwareError,
  GetHardwarePending,
  CreateHardwarePayload,
  CreateHardwarePending,
  CreateHardwareError,
  UpdateHardwareSuccess,
  UpdateHardwarePayload,
  UpdateHardwarePending,
  UpdateHardwareError,
  DeleteHardwarePending,
  DeleteHardwareError
} from './types';

// Actions
export const actions = {
  getHardware: (): HardwareActionTypes => ({
    type: types.GET_HARDWARE.REQUEST
  }),
  resetHardware: () => ({ type: types.RESET_HARDWARE }),
  updateHardware: (payload: UpdateHardwarePayload) => ({
    type: types.UPDATE_HARDWARE.REQUEST,
    payload
  }),
  resetError: () => ({ type: types.RESET_ERROR }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  createHardware: (payload: CreateHardwarePayload): HardwareActionTypes => ({
    type: types.CREATE_HARDWARE.REQUEST,
    payload
  }),
  deleteHardware: (payload: { id: string }): HardwareActionTypes => ({
    type: types.DELETE_HARDWARE.REQUEST,
    payload
  })
};

// Initial State
export const initialState: HardwareState = {
  hardware: [],
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: HardwareState = initialState, action: HardwareActionTypes): HardwareState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_HARDWARE.SUCCESS:
        draft.hardware = (action as GetHardwareSuccess).payload;
        break;
      case types.RESET_HARDWARE:
        draft.hardware = initialState.hardware;
        break;
      case types.GET_HARDWARE.PENDING:
      case types.CREATE_HARDWARE.PENDING:
      case types.UPDATE_HARDWARE.PENDING:
      case types.DELETE_HARDWARE.PENDING:
        draft.action.pending = (
          action as GetHardwarePending | CreateHardwarePending | UpdateHardwarePending | DeleteHardwarePending
        ).payload;
        break;
      case types.CREATE_HARDWARE.SUCCESS:
      case types.DELETE_HARDWARE.SUCCESS:
        draft.action.success = true;
        break;
      case types.UPDATE_HARDWARE.SUCCESS:
        const payload = (action as UpdateHardwareSuccess).payload;
        draft.action.success = true;
        if (draft.hardware.length) {
          const hardwareIndex = draft.hardware.findIndex((h) => h.id === (payload as Hardware).id);
          if (hardwareIndex > -1) {
            Object.assign(draft.hardware[hardwareIndex], payload);
          }
        }
        break;
      case types.CREATE_HARDWARE.ERROR:
      case types.UPDATE_HARDWARE.ERROR:
      case types.GET_HARDWARE.ERROR:
      case types.DELETE_HARDWARE.ERROR:
        draft.action.error = (
          action as CreateHardwareError | UpdateHardwareError | GetHardwareError | DeleteHardwareError
        ).payload;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
    }
  });
};
